import angular, {ILocationProvider, IModule, IRootScopeService, IScope} from "angular";
import {gettextCatalog} from "angular-gettext";
import {innlastingsindikatorForInjisering, InnlastingsindikatorKontroller} from "./moduler/basis/direktiver/innlastingsindikator";
import {OppgaverKontroller} from "./moduler/oppgave/OppgaverKontroller";
import {RelativDatoMedPrintKontroller} from "./direktiver/relativDatoMedPrint";
import {DatoperiodeMedPrintKontroller} from "./direktiver/datoPeriodeMedPrint";
import {InvitasjonGodtattKontroller} from "./moduler/innlogging/invitasjon/InvitasjonGodtattKontroller";
import {OpprettGruppeSteg2Kontroller} from "./moduler/innlogging/opprett/OpprettGruppeSteg2Kontroller";
import {byttPassordForInjisering, ByttPassordKontroller} from "./moduler/bruker/direktiver/byttPassord";
import {OpprettGruppeKontroller} from "./moduler/innlogging/opprett/OpprettGruppeKontroller";
import {EntitetKontroller} from "./moduler/entitet/EntitetKontroller";
import {GodtaInvitasjonKontroller as GodtaInvitasjonKontrollerInnlogging} from "./moduler/innlogging/invitasjon/GodtaInvitasjonKontroller";

import {LoggInnKontroller} from "./moduler/innlogging/LoggInnKontroller";
import {AngiNyttPassordKontroller} from "./moduler/innlogging/glemtpassord/AngiNyttPassordKontroller";
import {BrukerBekreftEpostKontroller} from "./moduler/bruker/brukerBekreftEpostKontroller";
import {ØnskerNyttPassordKontroller} from "./moduler/innlogging/glemtpassord/ØnskerNyttPassordKontroller";
import {KommentarerKontroller} from "./moduler/kommentar/KommentarerKontroller";
import {BasisKontroller} from "./moduler/basis/BasisKontroller";
import {Utlogging} from "./tjenester/Utlogging";
import {ModelloppdateringTjeneste} from "./tjenester/ModelloppdateringTjeneste";
import {MeldingTilBrukerVedInnlogging} from "./tjenester/MeldingTilBrukerVedInnlogging";
import {SystemmeldingApplikasjonTjeneste} from "./tjenester/SystemmeldingApplikasjonTjeneste";
import {SakWebRessurs} from "./tjenester/ressurser/SakWebRessurs";
import {MøteTjeneste} from "./moduler/møte/MøteTjeneste";
import {BeslutningTjeneste} from "./moduler/møte/BeslutningTjeneste";
import {OppgaveTjenesteWeb} from "./moduler/oppgave/OppgaveTjenesteWeb";
import {Dialog} from "./tjenester/Dialog";
import {injiserMetaForInjisering} from "./direktiver/injiserMeta";
import {appBannerForInjisering} from "./direktiver/appBanner";
import {escKeyForInjisering} from "./direktiver/escKey";
import {registrerAvatarKomponent} from "./komponenter/avatar/avatar";
import {EndringshendelserKontroller} from "./komponenter/endringshendelser/endringshendelser";
import {registrerMenyKomponent} from "./komponenter/meny/meny";
import {MedlemSelect} from "./komponenter/medlemSelect/medlemSelect";
import {BrukerSelect} from "./komponenter/brukerSelect/brukerSelect";
import {TipsKontroller} from "./komponenter/tips/tips";
import {WebHtmlFormatertKontroller} from "./komponenter/htmlFormatert/htmlFormatert";
import {registrerMButtonMedBekreftKlikkKomponent} from "./komponenter/mdButtonMedBekreftKlikk/mdButtonMedBekreftKlikk";
import {VisMeldingerTilBrukerKontroller} from "./moduler/basis/komponenter/visMeldingerTilBruker/visMeldingerTilBruker";
import {DashboardFilterKontroller} from "./moduler/dashboard/komponenter/dashboardFilter/dashboardFilter";
import {PlanerKontroller} from "./moduler/dashboard/komponenter/planer/planer";
import {OrgBrukereKontroller} from "./moduler/avtale/komponenter/brukere/brukere";
import {AksepterteBetingelserKontroller} from "./moduler/avtale/komponenter/aksepterteBetingelser/aksepterteBetingelser";
import {RedigerFaktureringsinformasjonKontroller} from "./moduler/avtale/komponenter/redigerFaktureringsinformasjon/redigerFaktureringsinformasjon";
import {RedigerAvtaleKontroller} from "./moduler/avtale/komponenter/redigerAvtale/redigerAvtale";
import {MøtemalKontroller} from "./moduler/gruppe/komponenter/møtemal/møtemal";
import {MøtemalskjemaKontroller} from "./moduler/gruppe/komponenter/møtemalskjema/møtemalskjema";
import {MalsakskjemaKontroller} from "./moduler/gruppe/komponenter/malsakskjema/malsakskjema";
import {AvtalerKontroller} from "./moduler/gruppe/komponenter/avtaler/avtaler";
import {LisensavtaleDialog} from "./moduler/gruppe/modale/lisensavtale/lisensavtaleDialog";
import {registrerEvalueringKomponent} from "./moduler/møte/komponenter/evaluering/evaluering";
import {PauseKontroller, SakKontroller} from "./moduler/møte/komponenter/sak/sak";
import {AvstemningKontroller} from "./moduler/møte/komponenter/avstemning/avstemning";
import {MøteEndringshendelserKontroller} from "./moduler/møte/komponenter/endringshendelser/endringshendelser";
import {registrerRedigerBeslutningDialog} from "./moduler/møte/modale/redigerBeslutningDialog/redigerBeslutningDialog";
import {registrerBrukerKomponent} from "./moduler/bruker/komponenter/bruker/bruker";
import {registrerRedigerOppgaveDialog} from "./moduler/oppgave/modale/redigerOppgaveDialog/redigerOppgaveDialog";
import {registrerVisOppgaveDialog} from "./moduler/oppgave/modale/visOppgaveDialog/visOppgaveDialog";
import {registrerOppgaverFilterKomponent} from "./moduler/oppgave/komponenter/oppgaverFilter/oppgaverFilter";
import {registrerOppgaverKanbanKomponent} from "./moduler/oppgave/komponenter/oppgaverKanban/oppgaverKanban";
import {registrerOppgaveStatusKomponent} from "./moduler/oppgave/komponenter/oppgaveStatus/oppgaveStatus";
import {registrerVisOppgaveKomponent} from "./moduler/oppgave/komponenter/visOppgave/visOppgave";
import {registrerFavorittKomponent} from "./moduler/favoritt/komponenter/favoritt/favoritt";
import {registrerListeFavoritterKomponent} from "./moduler/favoritt/komponenter/listeFavoritter/listeFavoritter";
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import moment from "moment";
import {LocationServices, StateProvider, StateService, TransitionService, UrlRouterProvider} from "@uirouter/angularjs";
import {Autentisering} from "felles/tjenester/Autentisering";
import _ from "lodash";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebModulnavn, WebNavigasjon} from "web/tjenester/WebNavigasjon";
import fellesModul, {lastModul} from "felles/fellesModul";
import {RopertKomponent} from "./komponenter/ropert/ropert";
import {AdministrasjonKontroller} from "./moduler/gruppe/komponenter/administrasjon/administrasjon";
import {ArkivKontroller} from "./moduler/arkiv/arkivKontroller";
import {ArkivWebRessurs} from "./tjenester/ressurser/ArkivWebRessurs";
import {OrgFakturainformasjonKontroller} from "./moduler/avtale/komponenter/fakturainformasjon/fakturainformasjon";
import {SøkKontroller} from "./moduler/basis/komponenter/søk/søk";
import {SøketreffKontroller} from "./moduler/basis/komponenter/søk/søketreff";
import {ForelderKontroller} from "./komponenter/forelder/forelder";
import {GruppeEndringshendelserKontroller} from "./moduler/gruppe/komponenter/endringshendelser/endringshendelser";
import {RedigerAvstemningDialog} from "./moduler/møte/modale/redigerAvstemningDialog/redigerAvstemningDialog";
import {MøteSakAvstemningerKontroller} from "./moduler/møte/komponenter/sakAvstemninger/sakAvstemninger";
import {RedigerMøtereferatKontroller} from "./moduler/møte/komponenter/møtereferat/redigerMøtereferat";
import {AktiverTotpDialog} from "./moduler/bruker/modale/aktiverTotp/aktiverTotpDialog";
import {AktiverTotpKontroller} from "./moduler/bruker/komponenter/aktiverTotp/aktiverTotp";
import {SikkerhetsinnstillingerKontroller} from "./moduler/bruker/komponenter/sikkerhetsinnstillinger/sikkerhetsinnstillinger";
import {PassordPromptDialogDialog} from "./moduler/bruker/modale/passordPrompt/passordPrompt";
import {ListeReserverkoderKontroller} from "./moduler/bruker/komponenter/listeReservekoder/listeReservekoder";
import {Debugger} from 'debug'
import {ListeAktiveAutentiseringstokenKontroller} from "./moduler/bruker/komponenter/listeAktiveAutentiseringstoken/listeAktiveAutentiseringstoken";
import {AvtaleAdministrasjonKontroller} from "./moduler/avtale/komponenter/administrasjon/administrasjon";
import {CriiptoBindBrukerKontroller} from "./moduler/innlogging/CriiptoBindBrukerKontroller";
import {PassordAutentiseringKontroller} from "./moduler/innlogging/komponenter/passordautentisering/passordautentisering";
import {AutentiseringKontroller} from "./moduler/innlogging/komponenter/autentisering/autentisering";
import {CriiptoAutentiseringKontroller} from "./moduler/innlogging/komponenter/criiptoautentisering/criiptoautentisering";
import {MøteoversiktKontroller} from "./moduler/dashboard/komponenter/møteoversikt/møteoversikt";
import {AktiverEidKontroller} from "./moduler/bruker/komponenter/aktiverEid/aktiverEid";
import {TemaMedBeskrivelseBeskrivelse} from "./moduler/møte/komponenter/temaMedBeskrivelse/temaMedBeskrivelse";
import {LogoKontroller} from "./moduler/innlogging/komponenter/logo/logo";
import {InlinePdfjsVisning} from "./komponenter/inlinePdfjsVisning/inlinePdfjsVisning";
import {DokumentKontroller} from "./moduler/møte/komponenter/dokumenter/dokument";
import {DokumenterKontroller} from "./moduler/møte/komponenter/dokumenter/dokumenter";
import {PdfjsMeldingshåndtering} from "felles/tjenester/PdfjsMeldingshåndtering";
import {Innlogging} from "./tjenester/Innlogging";
import {ÅrshjulKontroller} from "./moduler/dashboard/komponenter/årshjul/årshjul";
import {ÅrshjulinnslagskjemaKontroller} from "./moduler/gruppe/komponenter/årshjulskjema/årshjulinnslagskjema";
import {ÅrshjulinnslagKontroller} from "./moduler/gruppe/komponenter/årshjulskjema/årshjulinnslag";
import {KortKontroller} from "./direktiver/kort/kort";
import {KortsamlingKontroller} from "./direktiver/kort/kortsamling";
import {OpprettPlanSkjemaKontroller} from "./moduler/plan/komponenter/opprettplan/opprettplan";
import {OpprettPlanKontroller} from "./moduler/plan/OpprettPlanKontroller";
import {MeldingsinnstillingerKontroller} from "./moduler/bruker/komponenter/meldingsinnstillinger/meldingsinnstillinger";
import {RootScopeHjelper} from "felles/tjenester/RootScopeHjelper";
import {UiRouterFasade} from "../felles/infrastruktur/UiRouterFasade";
import {UiRouterWebFasade} from "./infrastruktur/UiRouterWebFasade";
import {LokaltDatalager} from "../felles/tjenester/LokaltDatalager";
import {WebSpråkvalgAvhengigheter} from "./tjenester/WebSpråkvalgAvhengigheter";
import {TidssonesøkKontroller} from "./komponenter/tidssonesøk/tidssonesøk";
import {TidssonevelgerKontroller} from "./komponenter/tidssonevelger/tidssonevelger";
import {SpråkvelgerKontroller} from "./direktiver/spraakvelger";
import {VisMedlemIListeKontroller} from "./moduler/gruppe/komponenter/visMedlemIListe/visMedlemIListe";
import {SkjermetTips} from "./moduler/møte/komponenter/skjermetTips/skjermetTips";
import {IkkePublisertTips} from "./moduler/møte/komponenter/ikkePublisertTips/ikkePublisertTips";
import {EndringshendelseKontroller} from "./komponenter/endringshendelse/endringshendelse";
import {PlanlisteKontroller} from "./moduler/gruppe/komponenter/planliste/planliste";
import {GruppeSikkerhetsinnstillingerKontroller} from "./moduler/gruppe/komponenter/sikkerhetsinnstillinger/sikkerhetsinnstillinger";
import {PlanKontroller} from "./moduler/gruppe/komponenter/plan/plan";
import {registrerRedigerPlanDialog} from "./moduler/gruppe/modale/redigerPlanDialog/redigerPlanDialog";
import {BekreftModilnummerKontroller} from "./moduler/bruker/komponenter/bekreftMobilnummer/bekreftMobilnummer";
import {AktiverSmsOtpKontroller} from "./moduler/bruker/komponenter/aktiverSmsOtp/aktiverSmsOtp";
import {MobiltelefonnummerInputKontroller} from "./komponenter/mobiltelefonnummerInput/mobiltelefonnummerInput";
import {VelgAkseptertSignaturmetodeKontroller} from "./moduler/møte/komponenter/velgAkseptertSignaturmetode/velgAkseptertSignaturmetode";
import {VisSignaturstatusKontroller} from "./moduler/dokument/komponenter/visSignaturstatus/visSignaturstatus";
import {RedigerEksterneDeltakereKontroller} from "./moduler/møte/komponenter/møteskjema/redigerEksterneDeltakere";
import {RedigerEksternDeltakerSkjemalinjeKontroller} from "./moduler/møte/komponenter/møteskjema/redigerEksternDeltakerSkjemalinje";
import {GruppeSpråkvelgerKontroller} from "./direktiver/gruppeSpraakvelger";
import {RedigerMøtetidspunkt} from "./moduler/møte/komponenter/møteskjema/redigerMøtetidspunkt";
import {NyttMøteDetaljerSkjemaKontroller} from "./moduler/møte/komponenter/nyttMøteSkjema/nyttMøteDetaljerSkjema";
import {NyttMøteVelgDeltakereSkjemaKontroller} from "./moduler/møte/komponenter/nyttMøteSkjema/nyttMøteVelgDeltakereSkjema";
import {NyttMøteVelgMalsakerKontroller} from "./moduler/møte/komponenter/nyttMøteSkjema/nyttMøteVelgMalsakerSkjema";
import {MøtemalDetaljerSkjemaKontroller} from "./moduler/gruppe/komponenter/møtemalskjema/møtemalDetaljerSkjema";
import {MalmøteTjeneste} from "./moduler/gruppe/MalmøteTjeneste";
import {BehandlingsmåteSkjemafeltKontroller} from "./moduler/møte/komponenter/behandlingsmåteSkjemafelt/behandlingsmåteSkjemafelt";
import {NyttMøtePubliseringSkjemaKontroller} from "./moduler/møte/komponenter/nyttMøteSkjema/nyttMøtePubliseringSkjema";
import {MøteKontroller} from "./moduler/møte/komponenter/møte/møte";
import {Transition} from "@uirouter/core/lib/transition/transition";
import {GruppeKontroller} from "./moduler/gruppe/komponenter/gruppe/gruppe";
import {GruppeOversiktKontroller} from "./moduler/gruppe/komponenter/gruppeOversikt/gruppeOversikt";
import {AvtaleKontroller} from "./moduler/avtale/komponenter/avtale/avtale";
import {DashboardArkfaner, DashboardKontroller} from "./moduler/dashboard/komponenter/dashboard/dashboard";
import {PlanTrunkertLinjeKontroller} from "./moduler/dashboard/komponenter/planTrunkertLinje/planTrunkertLinje";
import {IntroJsTjeneste} from "../felles/tjenester/IntroJs";
import {IngenMøterTipsKontroller} from "./moduler/dashboard/komponenter/ingenMøterTips/ingenMøterTips";
import {MøteProsessOversiktKontroller} from "./moduler/møte/komponenter/møteProsessOversikt/møteProsessOversikt";
import {MøteProsessStegKontroller} from "./moduler/møte/komponenter/møteProsessOversikt/møteProsessSteg/møteProsessSteg";
import {MøteProsessHandlinger} from "./moduler/møte/komponenter/møteProsessOversikt/møteProsessHandlinger";
import {MøteDeltakerTjeneste} from "./moduler/møte/MøteDeltakerTjeneste";
import {MdButtonMedLasterIndikatorKontroller} from "./komponenter/mdButtonMedLasterIndikator/mdButtonMedLasterIndikator";
import {registrerFlashVedNavigasjonforhindretDirective} from "./direktiver/flashVedNavigasjonforhindret";
import {FeltfeilINestedeSkjemaKontroller} from "./komponenter/feltfeilINestedeSkjema/feltfeilINestedeSkjema";
import {FeltEndretEventTriggerDirektiv} from "../felles/direktiver/feltEndretEventTrigger";
import {OppgaveStatusKomponent} from "./moduler/oppgave/komponenter/oppgaveStatusVelger/oppgaveStatusVelger";
import {InlineMeldingKomponent} from "./komponenter/inlineMelding/inlineMelding";
import {registrerNedgraderteNg2Tjenester} from "web/nedgraderteNg2Tjenester";
import {registrerNedgraderteNg2Komponenter} from "web/nedgraderteNg2Komponenter";
import {OppgavelisteKontroller} from "./moduler/oppgave/komponenter/oppgaveliste/oppgaveliste";
import {OppgaveKontroller} from "./moduler/oppgave/komponenter/oppgaveliste/oppgave/oppgave";
import {OppgavelistePageringKontroller} from "./moduler/oppgave/komponenter/oppgaveliste/paginering/oppgavelistePaginering";
import {RedigerMøtemalDialogTjeneste} from "web/moduler/gruppe/modale/redigerMøtemalDialog/redigerMøtemalDialog";
import {FilValidering} from "web/tjenester/FilValidering";
import {DetteErNyttDialog} from "web/moduler/dashboard/modale/detteErNyttDialog/detteErNyttDialog";
import {CriiptoBindFraTokenSesjonstjeneste} from "web/tjenester/CriiptoBindFraTokenSesjonstjeneste";
import {CriiptoBindBrukerFeiletKontroller} from "web/moduler/innlogging/CriiptoBindBrukerFeiletKontroller";
import {InlinePdfVisning} from "web/komponenter/inlineIframePdfVisning/inlinePdfVisning";
import {SakIListeKontroller} from "web/moduler/møte/komponenter/saksliste/sakIListe";
import IInjectorService = angular.auto.IInjectorService;

const debug: Debugger = require('debug')('webModul');
//global css
require('../../styles/web/hoved.scss');

/** Definerer vår hovedmodul (ng - angularjs - verden).
 * Se {@link WebHovedmodulNg2} for komponenter ol. skrevet i ng2. */
export function webModulMedNg2støtte(nedgradertNg2Modul:string): IModule {
    const modul = ajsWebModul([nedgradertNg2Modul]);

    //utvalgte ng2 tjenester/komponenter som skal være tilgjengelig for bruk i ajs-kode
    registrerNedgraderteNg2Tjenester(modul, nedgradertNg2Modul);
    registrerNedgraderteNg2Komponenter(modul, nedgradertNg2Modul)
    return modul;
}

/** Definerer vår hovedmodul (ng - angularjs - verden).
 * Se {@link WebHovedmodulNg2} for komponenter ol. skrevet i ng2. */
export default function webModul(): IModule {
    return ajsWebModul([]);
}


function ajsWebModul(tilleggmoduler:string[]): IModule {
    const modul = angular.module('lederplan-web', [
        require('angular-messages'),
        require('angular-sanitize'),
        require('angular-animate'),
        require('@uirouter/angularjs').default,
        require('ng-sortable'),
        lastModul('angular-velocity', require('velocity-animate'), require('velocity-animate/velocity.ui.js'), require('angular-velocity')), //angular-velocity krever import av velocity-animate og velocity.ui.js
        require('angular-elastic'),
        require('ng-file-upload'),
        lastModul('hl.sticky', require('angular-sticky-plugin')),
        require('angular-material'),
        lastModul('gettext', require('angular-gettext')),
        lastModul('smoothScroll', require('ngSmoothScroll')),

        fellesModul().name,

        ...tilleggmoduler
    ]);

    tjenester(modul);
    siderOgKomponenter(modul);
    navigasjon(modul);
    oppsett(modul);

    return modul;
}


function tjenester(modul: IModule) {
    modul
        .service(UiRouterFasade.regNavn, UiRouterWebFasade.forInjisering())
        .service(Innlogging.regNavn, Innlogging.forInjisering())
        .service(Utlogging.regNavn, Utlogging.forInjisering())
        .service(WebNavigasjon.regNavn, WebNavigasjon.forInjisering())
        .service(ModelloppdateringTjeneste.regNavn, ModelloppdateringTjeneste.forInjisering())
        .service(MeldingTilBrukerVedInnlogging.regNavn, MeldingTilBrukerVedInnlogging.forInjisering())
        .service(SystemmeldingApplikasjonTjeneste.regNavn, SystemmeldingApplikasjonTjeneste.forInjisering())
        .service(SakWebRessurs.regNavn, SakWebRessurs.forInjisering())
        .service(ArkivWebRessurs.regNavn, ArkivWebRessurs.forInjisering())

        .service(MalmøteTjeneste.regNavn, MalmøteTjeneste.forInjisering())
        .service(BeslutningTjeneste.regNavn, BeslutningTjeneste.forInjisering())
        .service(OppgaveTjenesteWeb.regNavn, OppgaveTjenesteWeb.forInjisering())
        .service(WebSpråkvalgAvhengigheter.regNavn, WebSpråkvalgAvhengigheter.forInjisering())
        .service(FilValidering.regNavn, FilValidering.forInjisering())
        .service(CriiptoBindFraTokenSesjonstjeneste.regNavn, CriiptoBindFraTokenSesjonstjeneste.forInjisering())
    ;
    MøteTjeneste.registrerTjenester(modul);
    MøteDeltakerTjeneste.registrerTjenester(modul);
    RedigerMøtemalDialogTjeneste.registrerTjeneste(modul);

    Dialog.registrerTjeneste(modul);
}


function siderOgKomponenter(modul: IModule) {
    // felles komponenter og direktiver
    modul
        .directive("injiserMeta", injiserMetaForInjisering())
        .directive("appBanner", appBannerForInjisering())
        .directive('escKey', escKeyForInjisering());
    registrerFlashVedNavigasjonforhindretDirective(modul);
    FeltEndretEventTriggerDirektiv.registrerDirektiv(modul);

    KortsamlingKontroller.registrerKomponent(modul);
    KortKontroller.registrerKomponent(modul);
    registrerAvatarKomponent(modul);
    EndringshendelserKontroller.registrerKomponent(modul);
    EndringshendelseKontroller.registrerKomponent(modul);
    registrerMenyKomponent(modul);
    MedlemSelect.registrerKomponent(modul);
    BrukerSelect.registrerKomponent(modul);
    TipsKontroller.registrerKomponent(modul);
    TidssonesøkKontroller.registrerKomponent(modul);
    MobiltelefonnummerInputKontroller.registrerKomponent(modul);
    TidssonevelgerKontroller.registrerKomponent(modul);
    ForelderKontroller.registrerKomponent(modul);
    WebHtmlFormatertKontroller.registrerKomponent(modul);
    registrerMButtonMedBekreftKlikkKomponent(modul);
    InlineMeldingKomponent.registrerKomponent(modul);
    RopertKomponent.registrerKomponent(modul);
    InlinePdfjsVisning.registrerKomponent(modul);
    InlinePdfVisning.registrerKomponent(modul);
    MdButtonMedLasterIndikatorKontroller.registrerKomponent(modul);
    FeltfeilINestedeSkjemaKontroller.registrerKomponent(modul);
    OppgaveStatusKomponent.registrerKomponent(modul);

    // i18n
    SpråkvelgerKontroller.registrerKomponent(modul);
    GruppeSpråkvelgerKontroller.registrerKomponent(modul);

    // Forside
    modul
        .controller(LoggInnKontroller.regNavn, LoggInnKontroller.forInjisering())
        .controller(CriiptoBindBrukerKontroller.regNavn, CriiptoBindBrukerKontroller.forInjisering())
        .controller(CriiptoBindBrukerFeiletKontroller.regNavn, CriiptoBindBrukerFeiletKontroller.forInjisering())
        .controller(ØnskerNyttPassordKontroller.regNavn, ØnskerNyttPassordKontroller.forInjisering())
        .controller(AngiNyttPassordKontroller.regNavn, AngiNyttPassordKontroller.forInjisering())
        .controller(OpprettGruppeKontroller.regNavn, OpprettGruppeKontroller.forInjisering())
        .controller(OpprettGruppeSteg2Kontroller.regNavn, OpprettGruppeSteg2Kontroller.forInjisering())
        .controller(GodtaInvitasjonKontrollerInnlogging.regNavn, GodtaInvitasjonKontrollerInnlogging.forInjisering())
        .controller(InvitasjonGodtattKontroller.regNavn, InvitasjonGodtattKontroller.forInjisering());
    AutentiseringKontroller.registrerKomponent(modul);
    PassordAutentiseringKontroller.registrerKomponent(modul);
    CriiptoAutentiseringKontroller.registrerKomponent(modul);
    LogoKontroller.registrerKomponent(modul);

    // Basis
    modul
        .controller(BasisKontroller.regNavn, BasisKontroller.forInjisering())
        .controller(InnlastingsindikatorKontroller.regNavn, InnlastingsindikatorKontroller.forInjisering())
        .directive("innlastingsindikator", innlastingsindikatorForInjisering());
    VisMeldingerTilBrukerKontroller.registrerKomponent(modul);
    SøkKontroller.registrerKomponent(modul);
    SøketreffKontroller.registrerKomponent(modul);

    // Administrasjon
    // Dashboard
    DashboardKontroller.registrerKomponent(modul);
    PlanerKontroller.registrerKomponent(modul)
    PlanTrunkertLinjeKontroller.registrerKomponent(modul)
    DashboardFilterKontroller.registrerKomponent(modul)
    MøteoversiktKontroller.registrerKomponent(modul);
    ÅrshjulKontroller.registrerKomponent(modul);
    IngenMøterTipsKontroller.registrerKomponent(modul);

    // Plan
    modul
        .controller(OpprettPlanKontroller.regNavn, OpprettPlanKontroller.forInjisering());
    OpprettPlanSkjemaKontroller.registrerKomponent(modul);


    // møte
    MøteKontroller.registrerKomponent(modul);
    registrerEvalueringKomponent(modul);
    RedigerMøtetidspunkt.registrerKomponent(modul);
    RedigerEksterneDeltakereKontroller.registrerKomponent(modul);
    RedigerEksternDeltakerSkjemalinjeKontroller.registrerKomponent(modul);
    NyttMøteDetaljerSkjemaKontroller.registrerKomponent(modul);
    NyttMøteVelgMalsakerKontroller.registrerKomponent(modul);
    NyttMøteVelgDeltakereSkjemaKontroller.registrerKomponent(modul);
    NyttMøtePubliseringSkjemaKontroller.registrerKomponent(modul);
    SakKontroller.registrerKomponent(modul);
    PauseKontroller.registrerKomponent(modul);
    SakIListeKontroller.registrerKomponent(modul);
    DokumenterKontroller.registrerKomponent(modul);
    DokumentKontroller.registrerKomponent(modul);
    AvstemningKontroller.registrerKomponent(modul);
    RedigerMøtereferatKontroller.registrerKomponent(modul);
    MøteEndringshendelserKontroller.registrerKomponent(modul);
    MøteSakAvstemningerKontroller.registrerKomponent(modul);
    TemaMedBeskrivelseBeskrivelse.registrerKomponent(modul);
    BehandlingsmåteSkjemafeltKontroller.registrerKomponent(modul);
    SkjermetTips.registrerKomponent(modul);
    IkkePublisertTips.registrerKomponent(modul);
    VelgAkseptertSignaturmetodeKontroller.registrerKomponent(modul);

    MøteProsessOversiktKontroller.registrerKomponent(modul);
    MøteProsessStegKontroller.registrerKomponent(modul);
    MøteProsessHandlinger.registrerTjeneste(modul);

    DetteErNyttDialog.registrerDialog(modul);
    registrerRedigerBeslutningDialog(modul);

    // Dokument
    VisSignaturstatusKontroller.registrerKomponent(modul);

    // Oppgaver
    modul
        .controller(OppgaverKontroller.regNavn, OppgaverKontroller.forInjisering());
    registrerRedigerOppgaveDialog(modul);
    registrerVisOppgaveDialog(modul);
    registrerOppgaverFilterKomponent(modul);
    registrerOppgaverKanbanKomponent(modul);
    registrerOppgaveStatusKomponent(modul);
    registrerVisOppgaveKomponent(modul);
    OppgavelisteKontroller.registrerKomponent(modul);
    OppgavelistePageringKontroller.registrerKomponent(modul);
    OppgaveKontroller.registrerKomponent(modul);

    // Kommentarer
    modul
        .controller(KommentarerKontroller.regNavn, KommentarerKontroller.forInjisering());

    // Gruppe
    GruppeOversiktKontroller.registrerKomponent(modul);
    GruppeKontroller.registrerKomponent(modul);
    VisMedlemIListeKontroller.registrerKomponent(modul);
    PlanKontroller.registrerKomponent(modul);
    PlanlisteKontroller.registrerKomponent(modul);
    registrerRedigerPlanDialog(modul);
    MøtemalKontroller.registrerKomponent(modul);
    GruppeSikkerhetsinnstillingerKontroller.registrerKomponent(modul);
    MøtemalskjemaKontroller.registrerKomponent(modul);
    MøtemalDetaljerSkjemaKontroller.registrerKomponent(modul);
    MalsakskjemaKontroller.registrerKomponent(modul);
    AvtalerKontroller.registrerKomponent(modul);
    GruppeEndringshendelserKontroller.registrerKomponent(modul);
    LisensavtaleDialog.registrerDialog(modul);
    RedigerAvstemningDialog.registrerDialog(modul);
    AdministrasjonKontroller.registrerKomponent(modul);
    ÅrshjulinnslagKontroller.registrerKomponent(modul);
    ÅrshjulinnslagskjemaKontroller.registrerKomponent(modul);

    // Avtale
    AvtaleKontroller.registrerKomponent(modul);
    OrgBrukereKontroller.registrerKomponent(modul);
    AksepterteBetingelserKontroller.registrerKomponent(modul);
    AvtaleAdministrasjonKontroller.registrerKomponent(modul);
    OrgFakturainformasjonKontroller.registrerKomponent(modul);
    RedigerFaktureringsinformasjonKontroller.registrerKomponent(modul);
    RedigerAvtaleKontroller.registrerKomponent(modul);

    // Bruker
    modul
        .controller(BrukerBekreftEpostKontroller.regNavn, BrukerBekreftEpostKontroller.forInjisering())
        .controller(ByttPassordKontroller.regNavn, ByttPassordKontroller.forInjisering())
        .directive("byttPassord", byttPassordForInjisering());
    registrerBrukerKomponent(modul);
    BekreftModilnummerKontroller.registrerKomponent(modul);
    AktiverSmsOtpKontroller.registrerKomponent(modul);
    AktiverTotpKontroller.registrerKomponent(modul);
    AktiverEidKontroller.registrerKomponent(modul);
    AktiverTotpDialog.registrerDialog(modul);
    PassordPromptDialogDialog.registrerDialog(modul);
    SikkerhetsinnstillingerKontroller.registrerKomponent(modul);
    MeldingsinnstillingerKontroller.registrerKomponent(modul);
    ListeReserverkoderKontroller.registrerKomponent(modul);
    ListeAktiveAutentiseringstokenKontroller.registrerKomponent(modul);

    //  Arkiv
    modul.controller(ArkivKontroller.regNavn, ArkivKontroller.forInjisering())

    // Entitet
    modul
        .controller(EntitetKontroller.regNavn, EntitetKontroller.forInjisering());

    // Print
    RelativDatoMedPrintKontroller.registrerKomponent(modul);
    DatoperiodeMedPrintKontroller.registrerKomponent(modul);

    // favoritter
    registrerFavorittKomponent(modul);
    registrerListeFavoritterKomponent(modul);
}

function oppsett(modul: IModule) {
    modul
      .config(['$sceDelegateProvider', ($sceDelegateProvider) => {
          $sceDelegateProvider.trustedResourceUrlList([
              // Allow same origin resource loads.
              'self',
              // Allow loading from our assets domain.  Notice the difference between * and **.
              // https://docs.angularjs.org/api/ng/service/$sce#:~:text=There%20are%20exactly%20two%20wildcard%20sequences%20%2D%20*%20and%20**
              'https://nyheter.styreplan.no/**'
          ]);
        }])
        .config([Konfigurasjon.regNavn, '$compileProvider', (konfigurasjon: Konfigurasjon, $compileProvider) => {
            if (konfigurasjon.miljø !== "test") $compileProvider.debugInfoEnabled(false);
        }])

        .config(['$mdAriaProvider', ($mdAriaProvider) => {
            // Globally disables all angular material ARIA warnings.
            $mdAriaProvider.disableWarnings();
        }])

        .config(['$mdThemingProvider', ($mdThemingProvider) => {

            //registrer white palett som arver fra grey (kun for å sikre at vi har def alle påkrevde toner,
            //setter 50 - som benyttes som bakgrunn - til #fff
            $mdThemingProvider.definePalette('hvit',  $mdThemingProvider.extendPalette('grey', {
                '50': '#fff',
                //bakgrunn hover ikke-aktiv knapp - skulle vært trondheim, men material legger på %20 opacity
                //merk at for md-fab-actions brukes den samme fargen - men uten opacity - overstyrere derfor spesifikt for dette i md-fargetilpasninger.scss
                '500': '#1f85ff'
            }));

            //registrer tilpasning av 'red' palett, endrer slik at tekstfarge blir hvit (default hue ser ut til å være 500 - derfor lagt 500 til i contrastStrongLightColors
            $mdThemingProvider.definePalette('rød',  $mdThemingProvider.extendPalette('red', {
                // By default, text (contrast) on this palette should be white with 87% opacity.
                contrastDefaultColor: 'light',
                // By default, for these lighter hues, text (contrast) should be 'dark'.
                contrastDarkColors: '50 100 200 300 400 A100 A200 A400',
                // By default, for these darker hues, text (contrast) should be white with 100% opacity.
                contrastStrongLightColors: '500 600 700 800 900 A700',
                'A700':'#cf1d16' //label felt ved feil, strek under felt ved feil ($feil-200-hoved)
            }));

            $mdThemingProvider.definePalette('blå', $mdThemingProvider.extendPalette('blue', {
                //ingen endringer på primær-knapper
                //  '800': '#1565c0', //bakgrunn primary raised (brukes uendret fra material blue)
                '700': '#1565c0', //checkbox, radioknapp, tab-tittel-tekst, aktiv-tab-markeringslinje ($profil-500-bergen)
                //  '600': '#fc0e32' // bakgrunn hover primær raised knapp (brukes uendret fra material blue)
                //å sette 500:#d1e6ff var gjort for å endre bakgrunnsfargen på valgt dato i date-picker
                //men 500 brukes også til 'md-select-menu md-content md-option[selected]' som tekstfarge - og til det er fargen alt for lys..
                //'500':'#d1e6ff'
            }));

            $mdThemingProvider
              .theme('default')
              .primaryPalette('blå', {
                  'default': '800', // bla buttons -> blir '#1d7c3e'
              })
              .accentPalette('blå', {
                  'default': '700' // bla tabs-markør-strek -> blir '#012c10'
              })
              .warnPalette('rød')
              .backgroundPalette('hvit');

            //palett for bruk i feks $mdDialog.prompt().theme('red')
            $mdThemingProvider.theme('red')
              .primaryPalette('rød');
        }])

        //kommenter inn denne for logging av alle ui-router state endringer
        //.run(['$trace', ($trace: any) => $trace.enable('TRANSITION')])

        /** Sørger for å signalisere til LokaltDatalager at datalager er tilgjengelig (på web trenger vi ikke å vente på noe spesielt). */
        .run([LokaltDatalager.regNavn, (lokaltDatalager:LokaltDatalager) => lokaltDatalager.initialisert() ])

        .run([Konfigurasjon.regNavn, (konfigurasjon: Konfigurasjon) =>
            konfigurasjon.klientType = "web"])

        //registrer navn på aktiv state i rootScope slik at navnet kan benyttes som css-klasse og dermed i css-selektorer
        .run([regNavn.ng.ui.$transitions, RootScopeHjelper.regNavn, ($transitions: TransitionService, rootScopeHjelper: RootScopeHjelper) => {
            $transitions.onSuccess({}, trans => { rootScopeHjelper.eksponerAktivTilstand(trans.to()) });
        }])

        /** konfigurerer angular material */
        .run([regNavn.md.$mdDateLocale, regNavn.gettext.gettextCatalog, ($mdDateLocaleProvider: angular.material.IDateLocaleProvider, gettextCatalog: gettextCatalog) => {
            $mdDateLocaleProvider.days = [
                gettextCatalog.getString('søndag'),
                gettextCatalog.getString('mandag'),
                gettextCatalog.getString('tirsdag'),
                gettextCatalog.getString('onsdag'),
                gettextCatalog.getString('torsdag'),
                gettextCatalog.getString('fredag'),
                gettextCatalog.getString('lørdag')];

            $mdDateLocaleProvider.shortDays = [
                gettextCatalog.getString('sø'),
                gettextCatalog.getString('ma'),
                gettextCatalog.getString('ti'),
                gettextCatalog.getString('on'),
                gettextCatalog.getString('to'),
                gettextCatalog.getString('fr'),
                gettextCatalog.getString('lø')];

            // mandag er første dag i uken
            $mdDateLocaleProvider.firstDayOfWeek = 1;

            // Bruk moment for å parse datoer
            $mdDateLocaleProvider.parseDate = function (dateString) {
                var m = moment(dateString, 'L', true);
                return m.isValid() ? m.toDate() : new Date(NaN);
            };
            $mdDateLocaleProvider.formatDate = function (date) {
                if (!date) return "";
                return moment(date).format('L');
            };
            $mdDateLocaleProvider.monthHeaderFormatter = function (date) {
                return moment(date).format("MMM YYYY")
            };

            // In addition to date display, date components also need localized messages
            // for aria-labels for screen-reader users.
            $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
                return 'uke ' + weekNumber;
            };
            $mdDateLocaleProvider.msgCalendar = 'Datovelger';
            $mdDateLocaleProvider.msgOpenCalendar = 'Vis datovelger';
        }])

        /** håndter manglende autentisering av request eller annen bruker logget ut i annen arkfane */
        .run([Utlogging.regNavn, (utlogging: Utlogging) => {
           utlogging.loggUtVedHendelser();
        }])

        /** start å lyttet til modellendringsmeldinger fra server når bruker har logget inn / kontekst lastet */
        .run([regNavn.ng.$rootScope, ModelloppdateringTjeneste.regNavn, Kontekst.regNavn, ($rootScope: IScope, modellOppdateringer: ModelloppdateringTjeneste, kontekst: Kontekst) => {
            $rootScope.$on(Autentisering.brukerAutentisertEvent, () => modellOppdateringer.startAbonnement());
            $rootScope.$on(Autentisering.brukerLoggetUtEvent, () => modellOppdateringer.avsluttAbonnement());

            //lytt til endringer i avtale - relast kontekst ved endringer (fordi avtale.kontaktperson kan ha blitt oppdatert)
            modellOppdateringer.vedAvtaleOppdatert(
                avtaleId => _(kontekst.autentiserteGrupper()).flatten().some(gruppe => gruppe.avtaleId === avtaleId),
                $rootScope,
                avtaleId => kontekst.relastBrukerOgGrupper()
            );
            //lytt til avtale terminert - relast kontekst (fordi org da sette i kun-les modus)
            modellOppdateringer.vedAvtaleAvtaleTerminert(
                avtaleId => _(kontekst.autentiserteGrupper()).flatten().some(gruppe => gruppe.avtaleId === avtaleId),
                $rootScope,
                avtaleId => kontekst.relastBrukerOgGrupper()
            );
            //lytt til endringer i gruppe - relast kontekst ved endringer (fordi tittel eller gruppe.oppsett.moetevurderingAktivert kan ha blitt oppdatert)
            modellOppdateringer.vedGruppeOppdatert(
                gruppeId => _(kontekst.autentiserteGrupper()).flatten().some(gruppe => gruppe.id === gruppeId),
                $rootScope,
                orgId => kontekst.relastBrukerOgGrupper()
            );
        }])

        .run([MeldingTilBrukerVedInnlogging.regNavn, (meldingTilBrukerVedInnlogging: MeldingTilBrukerVedInnlogging) => {
            meldingTilBrukerVedInnlogging.lyttTilBrukerLoggetInnEventOgVisMeldinger();
            meldingTilBrukerVedInnlogging.lyttTilBrukerRelastetEventOgVisMeldinger();
            meldingTilBrukerVedInnlogging.lyttTilKlientUtdatertEventOgVisMelding();
        }])

        .run([SystemmeldingApplikasjonTjeneste.regNavn, (systemmeldingApplikasjonTjeneste: SystemmeldingApplikasjonTjeneste) => {
            systemmeldingApplikasjonTjeneste.start();
        }])

        /** sørger for at kjørende innlastingsindikator skjules før sidenavigasjon */
        .run([regNavn.ng.ui.$transitions, regNavn.ng.$rootScope, ($transitions: TransitionService, $rootScope: IRootScopeService) => {
            $transitions.onStart({}, trans => { $rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig); });
        }])

        /** registrer meldingslytter som sørger for lukking av pdfjs vindu ved klikke på "tilbake" i pdfjs */
        .run([PdfjsMeldingshåndtering.regNavn, (pdfjsMeldingshåndtering: PdfjsMeldingshåndtering) => {
            pdfjsMeldingshåndtering.registrerGlobalVedLukkMeldingshåndtering(melding => {
                melding.kilde.close()
                window.focus();
            });
        }])

        /** håndter fornyelse (og utløp) av token */
        .run([Innlogging.regNavn, (innlogging: Innlogging) => {
            innlogging.initHåndterTokenfornyelse();
        }])

        /** håndter at bruker ble relastet i annen arkfane */
        .run([Kontekst.regNavn, (kontekst: Kontekst) => {
            kontekst.lyttTilBrukerRelastetIAnnenFane();
        }])

        .run([IntroJsTjeneste.regNavn, regNavn.gettext.gettextCatalog, (introJsTjeneste: IntroJsTjeneste, gettextCatalog: gettextCatalog) => {
            introJsTjeneste.leggTilIKø(
                introJsTjeneste.nyIntroduksjon('init.spøromvikanhjelpe')
                    .leggTilSteg(
                        1,
                        {
                            title: gettextCatalog.getString('Velkommen til Styreplan'),
                            intro: '<p>'+ gettextCatalog.getString('Nå skal vi vise deg noen av de viktigste funksjonene i systemet.') +'</p>' +
                                '<p>'+
                                    gettextCatalog.getString('Hvis du ikke ønsker å gjennomgå denne veilederen kan du') +' <a href="#">' + gettextCatalog.getString('trykke her') + '</a>. ' +
                                    gettextCatalog.getString('Du kan når som helst skru den på igjen via spørsmålstegnet nederst i hjørnet.') +
                                '</p>'
                        })
                    .kallNårSynlig((element, aktivtStegNummer) => {
                        element.querySelector('a')?.addEventListener(
                            'click',
                            () => {
                                introJsTjeneste.markerAbsoluttAlleSomVist()
                                introJsTjeneste.exit()
                            },
                           {once: true}
                        );
                        }
                    )
            );
        }])

        //automatisk innlogging via lokal-lagret jwt token
        //denne kan ikke ligge i lederplan-delte-moduler da brukerLoggetInnEvent-eventet ikke må bli fyrt
        //før alle lytter har fått anledning til å registrer seg
        //DENNE BØR LIGGE SOM SISTE .run BLOKK
        .run([Autentisering.regNavn, (autentisering: Autentisering) =>
            autentisering.initierKontekstFraLokaltTokenOgValider()])
    ;

}


/** navigasjons definisjoner for web, se https://ui-router.github.io/ng1/ */
export function navigasjon(modul: IModule) {
    function lesParameter(parameternavn:string){
        return [ regNavn.ng.ui.$transition$, ($transition$: Transition) => $transition$.params()[parameternavn] ]
    }

    modul
        //oppsett av UI Router
        .config([regNavn.ng.ui.$stateProvider, regNavn.ng.ui.$urlRouterProvider, regNavn.ng.$locationProvider,
            ($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider, $locationProvider: ILocationProvider) => {
                $stateProvider
                    // Innlogging og registrering
                    .state('forside', {
                        abstract: false,
                        url: "/forside",
                        template: "<ui-view></ui-view>",
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.anonym],
                            justerviewport: true,
                            visAppBanner: false
                        }
                    })

                    .state('forside.lederplan', {
                        url: "/lederplan",
                        template: require('./moduler/innlogging/forside.html')
                    })

                    // ny gruppe og bruker

                    .state('forside.opprettGruppe', {
                        url: "/ny-gruppe/start",
                        template: require('./moduler/innlogging/opprett/opprettGruppe.html'),
                        controller: OpprettGruppeKontroller.regNavn + " as ktr",
                    })
                    .state('forside.opprettGruppeSteg2', {
                        url: "/ny-gruppe/steg2",
                        template: require('./moduler/innlogging/opprett/opprettGruppeSteg2.html'),
                        controller: OpprettGruppeSteg2Kontroller.regNavn + " as ktr"
                    })

                    // innlogging

                    .state('forside.logginn', {
                        url: "/logg-inn?forespurtSide?huskmeg",
                        template: require('./moduler/innlogging/logginn.html'),
                        controller: LoggInnKontroller.regNavn + " as ktr",
                        data: {visAppBanner: true}
                    })

                    .state('forside.oidcrespons', {
                        url: "/oidcrespons?code&state&error",
                        template: require('./moduler/innlogging/logginn.html'),
                        controller: LoggInnKontroller.regNavn + " as ktr",
                        data: {visAppBanner: true}
                    })

                    .state('forside.bindbrukercriipto', {
                        url: "/openid-bindbruker?kryptertOpenIdIdentitet&openIdNavn&autentiseringsmetode&tokenvarighet",
                        template: require('./moduler/innlogging/criiptoBindBruker.html'),
                        controller: CriiptoBindBrukerKontroller.regNavn + " as ktr",
                    })

                    .state('forside.openid-bindbruker-feilet', {
                        url: "/openid-bindbruker-feilet",
                        template: require('./moduler/innlogging/criiptoBindBrukerFeilet.html'),
                        controller: CriiptoBindBrukerFeiletKontroller.regNavn + " as $ctrl"
                    })

                    // godta invitasjon
                    .state('forside.godtaInvitasjon', {
                        url: "/invitasjon/ny-bruker/:token?forespurtSide&medlemId",
                        template: require('./moduler/innlogging/invitasjon/godtaInvitasjon.html'),
                        controller: GodtaInvitasjonKontrollerInnlogging.regNavn + " as ktr"
                    })
                    .state('forside.invitasjonGodtatt', {
                        url: "/invitasjon/oppdater-brukerinformasjon",
                        template: require('./moduler/innlogging/invitasjon/invitasjonGodtatt.html'),
                        controller: InvitasjonGodtattKontroller.regNavn + " as ktr"
                    })

                    // glemt passord

                    .state('forside.glemt-passord', {
                        url: "/glemt-passord",
                        template: require('./moduler/innlogging/glemtpassord/ønskerNyttPassord.html'),
                        controller: ØnskerNyttPassordKontroller.regNavn + " as ktr"
                    })

                    .state('forside.glemt-passord-bekreftelse', {
                        url: "/glemt-passord-bekreftelse",
                        template: require('./moduler/innlogging/glemtpassord/bekrefelseEpostSendt.html'),
                    })

                    .state('forside.nytt-passord', {
                        url: "/nytt-passord/:token?epost",
                        template: require('./moduler/innlogging/glemtpassord/angiNyttPassord.html'),
                        controller: AngiNyttPassordKontroller.regNavn + " as ktr"
                    })

                    .state('forside.angi-nytt-passord-bekreftelse', {
                        url: "/nytt-passord-bekreftelse",
                        template: require('./moduler/innlogging/glemtpassord/angiNyttPassordBekreftelse.html')
                    })

                    //basis for alle ikke-innloggingssider
                    .state('innhold', {
                        abstract: true,
                        url: "/innhold",
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator, l.TilgansrollerBruker.ordinaer],
                            visAppBanner: true
                        },
                        template: require('./moduler/basis/basis.html'),
                        controller: BasisKontroller.regNavn + " as basisKtr"
                    })

                    //forside
                    .state('innhold.dashboard', {
                        url: '/dashboard?q&d&f',
                        component: 'wdDashboard',
                        resolve: {
                            aktivArkfane: lesParameter('aktivArkfane'),
                        },
                        params: {
                            q: {value: '', dynamic: true, inherit: true}, //serialisert dashboardfilter, se DashboardFilterKontroller
                            d: {value: '', dynamic: true, inherit: true}, //ekspanderte grupper, se PlanerKontroller
                            f: {value: '', dynamic: true, inherit: true}, //fokusert gruppedimensjon, se PlanerKontroller
                            aktivArkfane: null // sørger for at sist viste arkfane
                        },
                        data: {modulnavn: WebModulnavn.dashboard},
                        // reloadOnSearch: false
                    })
                    .state('innhold.dashboard.plan', {
                        url: '/plan',
                        params: {aktivArkfane: DashboardArkfaner.plan}
                    })
                    .state('innhold.dashboard.moeteliste', {
                        url: '/moeteliste',
                        params: {aktivArkfane: DashboardArkfaner.moeteliste}
                    })
                    .state('innhold.dashboard.aarshjul', {
                        url: '/aarshjul',
                        params: {aktivArkfane: DashboardArkfaner.aarshjul}
                    })

                    //administrasjon

                    .state('innhold.administrasjonSøk', {
                        url: "/administrasjonSoek",
                        template: '<administrasjon-sok-side></administrasjon-sok-side>',
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator],
                            visAppBanner: false,
                            modulnavn: WebModulnavn.administrasjon
                        }
                    })

                    .state('innhold.administrasjonBrukere', {
                        url: "/administrasjonBrukere",
                        template: '<administrasjon-brukere-side></administrasjon-brukere-side>',
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator],
                            visAppBanner: false,
                            modulnavn: WebModulnavn.administrasjon
                        }
                    })

                    .state('innhold.administrasjonAvtaler', {
                        url: "/administrasjonAvtaler",
                        template: '<administrasjon-avtaler-side></administrasjon-avtaler-side>',
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator],
                            visAppBanner: false,
                            modulnavn: WebModulnavn.administrasjon
                        }
                    })

                    .state('innhold.administrasjonMeldinger', {
                        url: "/administrasjonMeldinger",
                        template: '<administrasjon-meldinger></administrasjon-meldinger>',
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator],
                            visAppBanner: false,
                            modulnavn: WebModulnavn.administrasjon
                        }
                    })

                    .state('innhold.administrasjonAsynkOppgaver', {
                        url: "/administrasjonAsynkOppgaver",
                        template: '<administrasjon-asynk-oppgaver></administrasjon-asynk-oppgaver>',
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator],
                            visAppBanner: false,
                            modulnavn: WebModulnavn.administrasjon
                        }
                    })

                    .state('innhold.administrasjonSpørreskjemaer', {
                        url: "/administrasjonSpoerreskjemaer",
                        template: '<administrasjon-spoerreskjemaer></administrasjon-spoerreskjemaer>',
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator],
                            visAppBanner: false,
                            modulnavn: WebModulnavn.administrasjon
                        }
                    })

                    //plan

                    .state('innhold.planOpprett', {
                        url: "/plan/opprett?gruppeId&start&slutt",
                        template: require('./moduler/plan/opprettPlan.html'),
                        controller: OpprettPlanKontroller.regNavn + " as $ctrl",
                        data: {
                            modulnavn: WebModulnavn.plan,
                        }
                    })

                    //møte
                    //deltakerstatus param er satt i urler benyttet ifbm godkjenning av innkalling, se no.systemfabrikken.lederplan.konfigurasjon.ApplikasjonsAdresser.deltakerstatusOppdatert
                    .state('innhold.moete', {
                        url: '/moete/:id?deltakerstatus',
                        component: 'wmMøte',
                        resolve: {
                            id: lesParameter('id'),
                            aktivArkfane: lesParameter('aktivArkfane'),
                            sakId: lesParameter('sakId')
                        },
                        params: {
                            aktivArkfane: 'saker',
                            redigerRekkefølge: {value: false, dynamic: true, inherit: false},
                        },
                        data: {modulnavn: WebModulnavn.møte}
                    })
                    .state('innhold.moete.protokoll', {
                        url: '/protokoll',
                        params: {
                            aktivArkfane: 'protokoll',
                            /** dersom sann aktiveres redigeringsmodus */
                            rediger: {value: false, dynamic: true, inherit: false},
                            /** dersom sann tvinges gjenopprettelse av skjema fra eventuell skjemalås kallende bruker måtte være tilknyttet */
                            gjenopprettSkjema: {value: false, dynamic: true, inherit: false},
                            /** dersom sann vises referat generert fra lydopptak av møtet ekspandert i redigeringsmodus */
                            visGenerertForslag: {value: false, dynamic: true, inherit: false},
                            /** dersom sann aktiveres signeringsmodus  */
                            signer: {value: false, dynamic: true, inherit: false},
                            //følgende to param brukes for å vise protokolldokument i preview-modus
                            dokumentId: {value: null, dynamic: true, inherit: false},
                            forespurtAnnoteringId: {value: null, dynamic: true, inherit: false}
                        }
                    })
                    .state('innhold.moete.avstemning', {
                        url: '/avstemning',
                        params: {aktivArkfane: 'avstemning'}
                    })
                    .state('innhold.moete.endringshendelser', {
                        url: '/endringshendelser',
                        params: {aktivArkfane: 'endringshendelser'}
                    })
                    .state('innhold.moete.sak', {
                        url: '/sak/:sakId',
                        params: {redigerSak: {value: false, dynamic: true, inherit: false}}
                    })
                    .state('innhold.moete.sak.oppgave', {
                        url: '/oppgave/:oppgaveId'
                    })
                    .state('innhold.moete.sak.avstemning', {
                        url: '/avstemning/:avstemningId'
                    })
                    .state('innhold.moete.sak.beslutning', {
                        url: '/beslutning/:beslutningId'
                    })
                    .state('innhold.moete.sak.dokument', {
                        url: '/dokument/:dokumentId',
                        params: {forespurtAnnoteringId: {value: null, dynamic: true, inherit: false}}
                    })
                    .state('innhold.moete.sak.dokument.signer', {
                        url: '/signer',
                        params: {
                            forespurtAnnoteringId: {value: null, dynamic: true, inherit: false},
                            signer: {value: true, dynamic: true, inherit: false}
                        }
                    })

                    //kalender
                    /* ikke implementert
                    .state('kalender', {
                        url: "/kalender",
                        template: require('./moduler/kalender/kalender.html'),
                        controller: KalenderKontroller.regNavn + " as kalenderKtr"
                    })
                    */

                    //oppgaver
                    .state('innhold.oppgaver', {
                        url: "/oppgaver?q&v&p",
                        template: require('./moduler/oppgave/oppgaver.html'),
                        controller: OppgaverKontroller.regNavn + " as ktr",
                        data: {modulnavn: WebModulnavn.oppgave},
                        params: {
                            q: "",
                            v: "",
                            p: ""
                        },
                        reloadOnSearch: false
                    })

                    //kommentarer
                    .state('innhold.kommentarer', {
                        url: "/kommentarer",
                        template: require('./moduler/kommentar/kommentarer.html'),
                        controller: KommentarerKontroller.regNavn + " as kommentarerKtr",
                        data: {modulnavn: WebModulnavn.kommentar}
                    })

                    //avtale
                    .state('innhold.avtale', {
                        url: '/avtale/:avtaleId',
                        component: 'waAvtale',
                        resolve: {
                            avtaleId: lesParameter('avtaleId'),
                            aktivArkfane: lesParameter('aktivArkfane'),
                            visRedigerFaktureringsinformasjon: lesParameter('redigerFaktureringsinformasjon')
                        },
                        params: {
                            aktivArkfane: 'grupper',
                            redigerFaktureringsinformasjon: {value: false, dynamic: true, inherit: false}
                        },
                        data: {modulnavn: WebModulnavn.gruppe}
                    })
                    //egen state for å håndtere lenke til redigering av faktureringsinformasjon  - lenken benyttes i eposter
                    .state('innhold.avtale.avtaleRedigerFaktureringsinformasjon', {
                        url: '/redigerFaktureringsinformasjon',
                        params: {
                            aktivArkfane: 'grupper',
                            redigerFaktureringsinformasjon: {value: true, dynamic: true, inherit: false},
                        }
                    })
                    .state('innhold.avtale.brukere', {
                        url: '/brukere',
                        params: {aktivArkfane: 'brukere'}
                    })
                    .state('innhold.avtale.aksepterteBetingelser', {
                        url: '/aksepterteBetingelser',
                        params: {aktivArkfane: 'aksepterteBetingelser'}
                    })
                    .state('innhold.avtale.administrasjon', {
                        url: '/administrasjon',
                        params: {aktivArkfane: 'administrasjon'}
                    })

                    //grupper
                    .state('innhold.gruppeoversikt', {
                        url: '/gruppe',
                        component: 'wgGruppeOversikt',
                        resolve: {aktivArkfane: () => 'grupper'},
                        data: {modulnavn: WebModulnavn.gruppe}
                    })
                    .state('innhold.avtaleoversikt', {
                        url: '/avtaler',
                        component: 'wgGruppeOversikt',
                        resolve: {aktivArkfane: () => 'avtaler'},
                        data: {modulnavn: WebModulnavn.gruppe}
                    })
                    .state('innhold.brukerSikkerhetsinnstillinger', {
                        url: '/sikkerhetsinnstillinger',
                        component: 'wgGruppeOversikt',
                        resolve: {aktivArkfane: () => 'brukerSikkerhetsinnstillinger'},
                        data: {modulnavn: WebModulnavn.gruppe}
                    })
                    .state('innhold.brukerMeldingsinnstillinger', {
                        url: '/meldingsinnstillinger',
                        component: 'wgGruppeOversikt',
                        resolve: {aktivArkfane: () => 'brukerMeldingsinnstillinger'},
                        data: {modulnavn: WebModulnavn.gruppe}
                    })

                    //gruppe
                    .state('innhold.gruppe', {
                        url: "/gruppe/:gruppeId",
                        component: 'wgGruppe',
                        resolve: {
                            id: lesParameter('gruppeId'),
                            aktivArkfane: lesParameter('aktivArkfane'),
                            valgtMedlemId: lesParameter('medlemId'),
                            erRedigerMoetemal: lesParameter('rediger')
                        },
                        params: {aktivArkfane: 'medlemmer'},
                        data: {modulnavn: WebModulnavn.gruppe}
                    })
                    .state('innhold.gruppe.medlem', {
                        url: "/medlem/:medlemId",
                        params: {
                            aktivArkfane: 'medlemmer',
                            medlemId: null
                        }
                    })
                    .state('innhold.gruppe.moeter', { //@todo er denne i bruk? ser ikke sånn ut..
                        url: "/moeter",
                        params: {aktivArkfane: 'moeter'}
                    })
                    .state('innhold.gruppe.planer', {
                        url: "/planer",
                        params: {aktivArkfane: 'planer'}
                    })
                    .state('innhold.gruppe.aksjeeierbok', {
                        url: "/aksjeeierbok",
                        params: {aktivArkfane: 'aksjeeierbok'}
                    })
                    .state('innhold.gruppe.statistikk', {
                        url: "/statistikk",
                        params: {aktivArkfane: 'statistikk'}
                    })
                    .state('innhold.gruppe.konfigurasjon', {
                        url: "/konfigurasjon",
                        params: {aktivArkfane: 'konfigurasjon'}
                    })
                    .state('innhold.gruppe.endringshendelser', {
                        url: "/endringshendelser",
                        params: {aktivArkfane: 'endringshendelser'}
                    })
                  .state('innhold.gruppe.grupperBrukerMal', {
                      url: "/grupperBrukerMal",
                      params: {aktivArkfane: 'gruppeBrukerMal'}
                  })

                  .state('innhold.gruppe.moetemal', {
                        url: "/moetemal",
                        params: {
                            aktivArkfane: 'moetemal',
                            rediger: {value: false, dynamic: true, inherit: false}
                        }
                    })
                    .state('innhold.gruppe.administrasjon', {
                        url: "/administrasjon",
                        params: {aktivArkfane: 'administrasjon'}
                    })
                    .state('innhold.gruppe.sikkerhetsinnstillinger', {
                        url: "/sikkerhetsinnstillinger",
                        params: {aktivArkfane: 'sikkerhetsinnstillinger'}
                    })

                    //bruker
                    .state('innhold.brukerbekreftepost', {
                        url: "/bruker/bekreftepost/:token",
                        controller: BrukerBekreftEpostKontroller.regNavn + " as ktr",
                    })

                  // dokument - felles for arkiv og saksdokument
                  // brukes som url når man skriver dokument: i en ckeditor og lager lenke til ett dokument
                  // eks på url : http://localhost:8888/app/innhold/dokument/f8ed4bec-b7cd-4c7b-b5bb-e3ebf1a3b7b1 - Det er ID til dokumentversjon som brukes - men vi vil vise siste versjon av dokumentet.
                  .state('innhold.dokument', {
                      url: "/dokument/:dokumentVersjonId",
                      controller: [regNavn.ng.ui.$state, WebNavigasjon.regNavn, function ($state: StateService, webNavigasjon: WebNavigasjon) {
                          webNavigasjon.gåTilSakEllerArkivKnyttetTilDokumentVersjon($state.params['dokumentVersjonId'], true);
                      }]
                  })
                    //arkiv
                    .state('innhold.arkiv', {
                        url: "/arkiv",
                        template: require('./moduler/arkiv/arkiv.html'),
                        controller: ArkivKontroller.regNavn + " as $ctrl",
                        data: {modulnavn: WebModulnavn.arkiv}
                    })

                    .state('innhold.arkiv.mappe', {
                        url: "/:id"
                    })

                    .state('innhold.arkiv.dokument', {
                        url: "/:id/:dokumentId",
                        params: {forespurtAnnoteringId: {value: null, dynamic: true, inherit: false}}
                    })

                    .state('innhold.arkiv.dokument.signer', {
                        url: "/signer",
                        params: {
                            forespurtAnnoteringId: {value: null, dynamic: true, inherit: false},
                            signer: {value: true, dynamic: true, inherit: false}
                        }
                    })


                    // gå til entitet
                    .state('entitet', {
                        url: '/entitet/:type/:id',
                        controller: EntitetKontroller.regNavn + " as ktr",
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator, l.TilgansrollerBruker.ordinaer]
                        }
                    })

                    //redirigeringer
                    .state('redirigering', {
                        abstract: true,
                        url: "/redirigering",
                        data: {
                            tilgangsroller: [l.TilgansrollerBruker.administrator, l.TilgansrollerBruker.ordinaer],
                            visAppBanner: true
                        },
                    })

                    .state('redirigering.signerSaksdokument', {
                        url: "/signer-saksdokument/:dokumentId",
                        controller: [regNavn.ng.ui.$state, WebNavigasjon.regNavn, function ($state: StateService, webNavigasjon: WebNavigasjon) {
                            webNavigasjon.gåTilSignerSaksdokument($state.params['dokumentId'], true);
                        }]
                    })

                    .state('redirigering.signerArkivdokument', {
                        url: "/signer-arkivdokument/:dokumentId",
                        controller: [regNavn.ng.ui.$state, WebNavigasjon.regNavn, function ($state: StateService, webNavigasjon: WebNavigasjon) {
                            webNavigasjon.gåTilSignerArkivdokument($state.params['dokumentId'], true);
                        }]
                    })

                    .state('redirigering.sakEllerArkivKnyttetTilDokument', {
                        url: "/sak-eller-bibliotek-knyttet-til-dokument/:dokumentId",
                        controller: [regNavn.ng.ui.$state, WebNavigasjon.regNavn, function ($state: StateService, webNavigasjon: WebNavigasjon) {
                            webNavigasjon.gåTilSakEllerArkivKnyttetTilDokument($state.params['dokumentId'], true);
                        }]
                    })

                    .state('redirigering.oppgave', {
                        url: "/oppgave/:oppgaveId",
                        controller: [regNavn.ng.ui.$state, WebNavigasjon.regNavn, function ($state: StateService, webNavigasjon: WebNavigasjon) {
                            webNavigasjon.gåTilOppgave($state.params['oppgaveId'], true);
                        }]
                    })

                    .state('redirigering.entitetRef', {
                        url: "/entitetRef/:id/:type",
                        controller: [regNavn.ng.ui.$state, WebNavigasjon.regNavn, function ($state: StateService, webNavigasjon: WebNavigasjon) {
                            webNavigasjon.gåTilEntitetRef({ id: $state.params['id'], type: $state.params['type'] }, true);
                        }]
                    })

                    //legacy urler

                    /** no.systemfabrikken.lederplan.konfigurasjon.ApplikasjonsAdresser.sak */
                    .state('innhold.sak', {
                        url: "/sak/:sakId",
                        controller: [regNavn.ng.ui.$state, WebNavigasjon.regNavn, function ($state: StateService, webNavigasjon: WebNavigasjon) {
                            webNavigasjon.gåTilSak($state.params['sakId']);
                        }]
                    })
                    /** no.systemfabrikken.lederplan.konfigurasjon.ApplikasjonsAdresser.møteProtokoll */
                    .state('innhold.protokoll', {
                        url: "/protokoll/:id",
                        controller: [regNavn.ng.ui.$state, WebNavigasjon.regNavn, function ($state: StateService, webNavigasjon: WebNavigasjon) {
                            webNavigasjon.gåTilMøteProtokoll($state.params['id']);
                        }]
                    })
                ;


                /** Redirigerer til innloggingsiden dersom ingen bruker er innlogget, ellers vises startsiden (slik denne er definert i WebNavigasjon) */
                $urlRouterProvider.otherwise(($injector: IInjectorService, $location: LocationServices) => {
                    var kontekst = $injector.get<Kontekst>(Kontekst.regNavn);
                    var navigasjon = $injector.get<WebNavigasjon>(WebNavigasjon.regNavn);
                    debug(`ukjent url ${$location.url()} forespurt, ${kontekst.erAutentisert() ? 'bruker innlogget, går til startsideUrl' : 'ingen bruker innlogget, går til innloggingssidenUrl'}`);
                    if (kontekst.erAutentisert()) return navigasjon.startsideUrl();
                    return navigasjon.innloggingssidenUrl();
                });

                // enabler HTML5 History API basert navigasjon - betinger web-server-oppsett med rewrites av requester
                // samt setting av <base href="/app/"> i index-web.html
                $locationProvider.html5Mode(true);
            }]);

}
